import { render } from "./EstruturaItem.vue?vue&type=template&id=4316153c&scoped=true"
import script from "./EstruturaItem.vue?vue&type=script&lang=js"
export * from "./EstruturaItem.vue?vue&type=script&lang=js"

import "./EstruturaItem.vue?vue&type=style&index=0&id=4316153c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4316153c"]])

export default __exports__